import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const createEnterpriseSearchExperimentImpression = () => {
  EnterpriseExperiments.get('enterpriseSearchShadow');
};
